export class AuthDevice {
  id: string;
  platform: string;
  os: string;
  browser: string;
  version: string;
  ip: string;
  lastLoginAction: Date;

  public setId(id: string): AuthDevice {
    if(typeof id === 'string') {
      this.id = id;
    }
    return this;
  }

  public setPlatform(platform: string): AuthDevice {
    if(typeof platform === 'string') {
      this.platform = platform;
    }
    return this;
  }

  public setOs(os: string): AuthDevice {
    if(typeof os === 'string') {
      this.os = os;
    }
    return this;
  }

  public setBrowser(browser: string): AuthDevice {
    if(typeof browser === 'string') {
      this.browser = browser;
    }
    return this;
  }

  public setVersion(version: string): AuthDevice {
    if(typeof version === 'string') {
      this.version = version;
    }
    return this;
  }

  public setIp(ip: string): AuthDevice {
    if(typeof ip === 'string') {
      this.ip = ip;
    }
    return this;
  }

  public setLastLoginAction(date: Date): AuthDevice {
    if(date instanceof Date) {
      this.lastLoginAction = date;
    }
    return this;
  }

  fromResponse(response) {

    let date: Date;
    if(response.lastLoginAction) {
      date = new Date(response.lastLoginAction);
    }

    this
      .setId(response.id)
      .setPlatform(response.platform)
      .setOs(response.os)
      .setBrowser(response.browser)
      .setVersion(response.version)
      .setIp(response.ip)
      .setLastLoginAction(date);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/profile/auth-device.model.ts